import React from "react";
import Gimage from "../../Assets/Ankush/homepagegirl.png";
import VideoPlayer from "../../Video/VideoPlayer";
import "./Content.css";

const Content = () => {
  return (
    <div className="content box-border shadow-md rounded-md">
      <div className="content-description">
        <h3 className="w-full">
          New York Cosmetics is a wholesale distributor of brand-name cosmetics,
          skincare, nail polish, haircare, and HBA merchandise.
        </h3>
        {/* <VideoPlayer url="https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/DigitalCatalogue.mp4" /> */}
        <div>
          <img src={Gimage} alt="NYC Logo" className="client-photo1" />
          <p className="">
            We are one of the nation’s leading wholesalers in our categories.
            Our story begins around 6 years ago in 2015 when we started out in a
            small basement in Brooklyn. Today we operate out of our warehouse /
            office / showroom in Passaic New Jersey out of a 50k Square Foot
            Facility. We offer our customers wholesale and closeout prices that
            will allow you to compete with large corporate retailers such as
            Amazon, Wal-Mart, Target, Home Depot, Best Buy, ETC. If you are
            looking for a reliable source that can offer competitive pricing,
            comprehensive product variety, and outstanding service then New York
            Cosmetics is the company for you. We have always been dedicated to
            building long term relationships with our clients by providing high
            quality service at very competitive prices. We conduct business in
            an honest and ethical manner.
          </p> 
         </div>
        {/* <h4> Follow us:@NewyorkCosmetics</h4> */}
        <h4>Please log in at the top right to access our inventory</h4>
      </div>
    </div>
  );
};

export default Content;
